import React from 'react'
import MapComponent from '../Component/map/map'
import Layout from '../Component/layout/main-layout'
import { useTranslation } from 'react-i18next'
import layoutBgImg from '../Images/layout/map.jpg'
import GlobalLayout from '../Component/layout/global-layout'


const Map = () => {
    const { t } = useTranslation()
    return (
        <GlobalLayout
            title={`${t('contacts')} - ${t('supreme_court')} ${t('turkmenistan')}`}
            keywords="Türkmenistanyň kartasy, Kazyýet edaralary, Kazyýet edaralarynyň kartasy,
                      Turkmenistanyn kartasy, Kazyyet edaralary, Kazyyet edaralarynyn kartasy, Karta"
        >
            <div className='mb-20'>
                <Layout
                    title={t('contacts')}
                    layoutBgImg={layoutBgImg}
                />
                <div className='mt-8 px-4 xxl:px-12 xxxl:px-32 xxxxl:px-64 xxxxxl:px-[400px] 
                            xxxxxxl:px-[650px] xxxxxxxl:px-[1600px] xxxxxxxxl:px-[2400px]'>
                    <MapComponent />
                </div>
            </div>
        </GlobalLayout>
    )
}

export default Map